module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MU - Mauritius.4168085a.svg";